import { useState } from "react";
import useMobile from "../../hooks/useMobile";
import { useQuery } from "react-query";
import { getCoachList, getVenues } from "../../api/user/play/Play";
import { Modal , Text, ModalContent, ModalBody, Flex, ModalHeader, Spacer, ModalCloseButton, Divider, Center, Icon, Box, Spinner} from "@chakra-ui/react";
import useWindowHeight from "../../hooks/useWindowHeight";

import SelectAsInput from "../input/SelectAsInput";
import { CoachTagItem } from "../../pages/host/CreateEvent";
import CalendarTimeframeSelect from "../calendar/CalendarTimeframeSelect";
import { getEvents } from "../../api/user/events/Events";
import { TbDownload, TbFolderCancel } from "react-icons/tb";
import { getCoachPayouts } from "../../api/user/settings/Settings";

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

declare module 'jspdf' {
    interface jsPDF {
      autoTable: (config: any) => jsPDF;
    }
  }


const CoachReportModal = ({ isOpen, onClose} : {
    isOpen : boolean,
    onClose : () => void,
}) => {

    const isMobile = useMobile(600)
    const isTablet = useMobile(900)

    const currentDate = new Date();
    const [filterMonth,setFilterMonth] = useState(currentDate.getMonth())
    const [filterYear,setFilterYear] = useState(currentDate.getFullYear())


    //const [startDate,setStartDate] = useState<Date|null>(null)
    //const [endDate,setEndDate] = useState<Date|null>(null)



    // useEffect(() => {
    //     setParams({...params, start_date : formatDate(startDate)})
    // }, [startDate])

    // useEffect(() => {
    //     setParams({...params, end_date : formatDate(endDate)})
    // }, [endDate])

    const [coachSelected, setCoachSelected] = useState<any[]>([])
    const [venueSelected, setVenueSelected] = useState<any[]>([])
    const [eventSelected, setEventSelected] = useState<any[]>([])
    const [min_date, setMinDate] = useState<Date | null>(null)
    const [max_date, setMaxDate] = useState<Date | null>(null)
    
    



    const windowHeight = useWindowHeight()
    
    const [ coach, setCoach ] = useState("")
    const coaches = useQuery(["getCoaches", 'is_coach', coach], () => getCoachList({search : coach, page_size : 5, page : 1, is_coach : true}))
    const coachOptions = coaches.data?.profiles?.map((c:any) => ({name : c.display_name, id : c.id, avatar : c.profile_image})) || []

    

    const [ venue, setVenue ] = useState("")
    const venues = useQuery(["getVenues", venue], () => getVenues({venue_search : venue, hide_blank : true, page_size : 5, page : 1}))
    const venueOptions = venues.data?.venues?.filter((c:any) => venueSelected.every(((d:any) => d.id != c.id))).map((c:any) => ({name : c.name, id : c.id, image : c.images[0]})) || []

    const [ event, setEvent ] = useState("")
    const events = useQuery(["getEvents", event], () => getEvents({search : event, page_size : 5, page : 1, venues : venueSelected.map((c:any) => c.id)}))
    const eventOptions = events.data?.events?.filter((c:any) => eventSelected.every(((d:any) => d.id != c.id))).map((e:any) => ({name : e.title, id : e.id, avatar : (e?.venue?.images.length > 0) ? e?.venue?.images?.[0] : ""})) || []

    const report = useQuery(["getCoachPayouts", eventSelected, coachSelected, venueSelected, min_date, max_date], () => getCoachPayouts({
        events : eventSelected.map((c:any) => c.id).join(","),
        venues : venueSelected.map((c:any) => c.id).join(","),
        coaches : coachSelected.map((c:any) => c.id).join(","),
        min_date : min_date ? min_date.toISOString() : "",
        max_date : max_date ? max_date.toISOString() : "",
    }))

    function sanitizeTime(hours: number): string {
        const wholeHours = Math.floor(hours);
        const minutes = Math.round((hours - wholeHours) * 60);
        return `${wholeHours}h ${minutes}m`;
    }

    const generatePDF = () => {
        const doc : any = new jsPDF();

         // Format the date range
    let dateRangeText = "(All time)";
    if (min_date && max_date) {
        const formattedMinDate = min_date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        const formattedMaxDate = max_date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        dateRangeText = `(Date range: ${formattedMinDate} - ${formattedMaxDate})`;
    } else if (min_date) {
        const formattedMinDate = min_date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        dateRangeText = `(Date range: From ${formattedMinDate})`;
    } else if (max_date) {
        const formattedMaxDate = max_date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        dateRangeText = `Date range: Until ${formattedMaxDate}`;
    }

        doc.text('Payouts ', 14, 15);
        
        doc.setFontSize(12);
        doc.text(dateRangeText, 38, 15);
        doc.text("Total: $" + report?.data.reduce((acc : number, row : any) => acc + row.total, 0).toString(), 14, 25);
        // Calculate total earnings per coach
        const coachEarnings: { [key: string]: { name: string, hours : number, total: number } } = {};

        report.data.forEach((row : any) => {
            if (!coachEarnings[row.coach_name]) {
            coachEarnings[row.coach_name] = { 
                name: row.coach_name, 
                hours: 0,
                total: 0 };
            }
            coachEarnings[row.coach_name].total += row.total;
            coachEarnings[row.coach_name].hours += row.hours_worked;
        });

        // Convert coachEarnings object to an array for autoTable
        const coachEarningsArray = Object.keys(coachEarnings).map((name) => {
            return [
            coachEarnings[name].name,
            sanitizeTime(coachEarnings[name].hours),
            "$" + coachEarnings[name].total.toFixed(2),
            ];
        });

        // First Table: Total earnings per coach
        doc.autoTable({
            startY: 30,
            head: [['Coach Name',"Total Hours Worked", 'Total Earnings']],
            body: coachEarningsArray,
        });

        // Second Table: Detailed event information
        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 10, // Start after the first table
            head: [['Name', 'Hourly Rate', 'Hours Worked', 'Total Rate', 'Event Name', 'Event Date']],
            body: report.data.map((row : any) => [
                row.coach_name,
                "$" + row.hourly_rate.toFixed(2),
                sanitizeTime(row.hours_worked),
                "$" + row.total.toFixed(2),
                row.event_name,
                formatDate(row.event_date),
            ]),
        });
        
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    
        // Generate the PDF and save it with the formatted name
        doc.save(`LVBL_Payouts_${formattedDate}.pdf`);
      };

      
    
      const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
      };



    
    
    return <Modal isOpen={isOpen} onClose={onClose} scrollBehavior='inside'>
        <ModalContent 
            boxShadow='0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D1C'
            top={isTablet ? isMobile ? '230px' : '116px' : '80px' }
            right={isTablet ? isMobile ? 0 : '20px' :'calc(50% - 194px)'}
            w={isMobile ? '100%' : '372px'} p='20px'
            h={isMobile ? `${windowHeight - 230}px` : undefined}
            position='absolute'
        >
        <ModalHeader
            fontSize='22px'
            color='#171C22'
            p='0' lineHeight='28px'
            
        >
            Download Report
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p='0'>
        <Text variant='title' fontSize='md' mt='10px' mb='5px'>Select Date Range</Text>
            <CalendarTimeframeSelect 
                month={filterMonth}
                year={filterYear}
                setMonth={setFilterMonth}
                setYear={setFilterYear}
                startDate={min_date}
                endDate={max_date}
                setStartDate={(value : Date | null) => setMinDate(value)}
                setEndDate={(value : Date | null) => setMaxDate(value)}
            />

            <Spacer h='10px' />




            <Text variant='title' fontSize='md' mt='10px' mb='5px'>Location</Text>
            <SelectAsInput
                value={null}
                onChange={(value : any) => {
                    if(value) {
                        setVenueSelected([...venueSelected, value])
                    }
                }}
                search={venue}
                onSearchChange={venue => setVenue(venue)}
                options={venueOptions}
                isLoading={venues.isLoading}
                placeholder="Search venues..."
                h='40px'
                w='100%'
            />

            
            <Flex gap='12px' flexWrap='wrap'>
                {venueSelected.map((c : any,i : number) => {
                    return <CoachTagItem 
                        key={i}
                        name={c.name} avatar={c.image}
                        onClick={() => {
                            setVenueSelected(venueSelected.filter((d:any) => d.id != c.id))
                        }}
                        isSelected
                    />
                })}
                

            </Flex>

            <Text variant='title' fontSize='md' mt='10px' mb='5px'>Events</Text>
            <SelectAsInput
                value={null}
                onChange={(value : any) => {
                    if(value) {
                        setEventSelected([...eventSelected, value])
                    }
                }}
                search={event}
                onSearchChange={event => setEvent(event)}
                options={eventOptions}
                isLoading={events.isLoading}
                placeholder="Search event name..."
                h='40px'
                w='100%'
            />
            
            <Flex gap='12px' flexWrap='wrap'>
                {eventSelected.map((c : any,i : number) => {
                    return <CoachTagItem 
                        key={i}
                        name={c.name} avatar={c.profile_image}
                        onClick={() => {
                            setEventSelected(eventSelected.filter((d:any) => d.id != c.id))
                        }}
                        isSelected
                    />
                })}
                

            </Flex>

            <Text variant='title' fontSize='md' mt='10px' mb='5px'>Coaches</Text>
            <SelectAsInput
                value={null}
                onChange={(value : any) => {
                    if(value) {
                        setCoachSelected([...coachSelected, value])
                    }
                }}
                search={coach}
                onSearchChange={coach => setCoach(coach)}
                options={coachOptions}
                isLoading={coaches.isLoading}
                placeholder="Search coaches..."
                h='40px'
                w='100%'
            />

            
            <Flex gap='12px' flexWrap='wrap'>
                {coachSelected.map((c : any,i : number) => {
                    return <CoachTagItem 
                        key={i}
                        name={c.name} avatar={c.profile_image}
                        onClick={() => {
                            setCoachSelected(coachSelected.filter((d:any) => d.id != c.id))
                        }}
                        isSelected
                    />
                })}
                

            </Flex>

            <Divider m='10px 0 20px 0' />

            <Center h="200px">
                {report.isLoading ? <Spinner size="xl"/> :
                report?.data.length == 0 ? 
                <Box cursor="cancelled">
                    <Center mb="8px"><Icon as={TbFolderCancel} w='40px' h='40px' color='grey' /></Center>
                    <Center><Text>No payouts found</Text></Center>
                </Box>
                : 
                <Box cursor="pointer" onClick={() => generatePDF()}>
                    <Center mb="8px"><Icon as={TbDownload} w='40px' h='40px' color='grey' /></Center>
                    <Center><Text>Download the payouts for your coaches</Text></Center>
                </Box>}
                
            </Center>

            
        </ModalBody>
       </ModalContent>
    </Modal>
}

export default CoachReportModal